import { TamediaStyles } from "@ta-interaktiv/microfrontend-template-helpers";
import { ReactElement, useContext } from 'react'
import styled from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import Grid from 'components/Grid'
import Country from 'components/Country'
import Header from 'components/Header'
import EuGains from 'components/EuGains'
import GlobalContext from 'Contexts/GlobalContext'
import { de, fr } from 'Globals/locale'
import { TextWidth } from '@ta-interaktiv/react-disco-grid'

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const colors = {
    farleft: '#9E272F',
    left: '#DE666F',
    middle: colorMode === 'dark' ? '#575247' : '#EFECE0',
    middlepopulist: colorMode === 'dark' ? '#A09C8A' : '#A09C8A',
    right: '#6F7187',
    farright: '#202346',
  }

  const currentLocale = tenant.lang == 'fr' ? fr : de

  const modules: { [key: string]: ReactElement } = {
    grid: (
      <Grid
        titleText={properties?.titleText}
        subTitleText={properties?.subTitleText}
        colorMode={colorMode}
        colors={colors}
        tenant={tenant}
      />
    ),
    country: (
      <Country
        iso={properties?.iso ? properties.iso : 'CHE'}
        titleText={properties?.titleText}
        htmlText={properties?.htmlText}
        layout={properties?.layout ? properties.layout : 'left'}
        colors={colors}
        colorMode={colorMode}
        tenant={tenant}
      />
    ),
    header: (
      <Header
        titleText={properties?.titleText}
        leadText={properties?.leadText}
        authors={
          properties && properties?.authors
            ? JSON.parse('[' + properties?.authors + ']')
            : undefined
        }
        publishDate={properties?.publishDate}
        colorMode={colorMode}
      />
    ),
    eu: (
      <TextWidth>
        <EuGains
          titleText={properties?.titleText}
          colorMode={colorMode}
          tenant={tenant}
        />
      </TextWidth>
    ),
  }
  return (
    <AppContainer
      isHeader={properties?.module === 'header'}
      $colorMode={colorMode}
    >
      <GlobalContext.Provider
        value={{
          tenant,
          colorMode,
          trackEvent,
          properties,
          locale: currentLocale,
        }}
      >
        {' '}
        {properties && <>{modules[properties.module]}</>}
      </GlobalContext.Provider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)<{ isHeader: boolean }>`${GlobalVariables}
  //hacky stuff for positioning the header
  z-index: ${(prop) => (prop.isHeader ? 99999 : 1)};
  position: relative;
  top: ${(prop) => (prop.isHeader ? '-16px' : 0)};
  @media (min-width: 1931px) {
    margin: ${(prop) => (prop.isHeader ? '0 -25%' : 'unset')};
  }
  @media only screen and (max-width: 1024px) {
    padding: 0;
  }

  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
`

export default MainComponent
